import backendCall from './AxiosService';
import type { ActivityFeedQuery, ActivityFeedResponse, ActivityStats } from '@/types/activityFeed';

class ActivityFeedService {
    /**
     * Get activity feed entries with filtering
     */
    async getActivityFeed(query: ActivityFeedQuery = {}): Promise<ActivityFeedResponse> {
        const params = new URLSearchParams();
        
        // Add query parameters
        if (query.limit) params.append('limit', query.limit.toString());
        if (query.offset) params.append('offset', query.offset.toString());
        if (query.entity_id) params.append('entity_id', query.entity_id);
        if (query.user_id) params.append('user_id', query.user_id.toString());
        if (query.start_date) params.append('start_date', query.start_date);
        if (query.end_date) params.append('end_date', query.end_date);
        
        // Handle arrays
        if (query.event_types) {
            query.event_types.forEach(type => params.append('event_types', type));
        }
        if (query.entity_types) {
            query.entity_types.forEach(type => params.append('entity_types', type));
        }
        if (query.entity_type) {
            params.append('entity_type', query.entity_type);
        }
        if (query.severity) {
            query.severity.forEach(sev => params.append('severity', sev));
        }

        const response = await backendCall.get(`/activity-feed?${params.toString()}`);
        return response.data;
    }

    /**
     * Get activity statistics
     */
    async getActivityStats(timeRange: 'today' | 'week' | 'month' = 'today'): Promise<ActivityStats> {
        const response = await backendCall.get(`/activity-feed/stats?range=${timeRange}`);
        return response.data.data;
    }

    /**
     * Mark activities as read (future enhancement)
     */
    async markAsRead(activityIds: string[]): Promise<void> {
        await backendCall.post('/activity-feed/mark-read', { activity_ids: activityIds });
    }

    /**
     * Export activity feed data
     */
    async exportActivityFeed(query: ActivityFeedQuery = {}): Promise<Blob> {
        const params = new URLSearchParams();
        
        if (query.start_date) params.append('start_date', query.start_date);
        if (query.end_date) params.append('end_date', query.end_date);

        const response = await backendCall.get(`/activity-feed/export?${params.toString()}`, {
            responseType: 'blob'
        });
        
        return response.data;
    }
}

export const activityFeedService = new ActivityFeedService();
export default activityFeedService;